import { STOP_TOOLTIP_CONFIG } from 'react/utils/stopUtils';

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.MarkerDeparture = class {
  constructor(map, routeId) {
    const kind = 'DEPARTURE';
    this.getDeparturesAndDrawOnMap = () => {
      const success = (stops) => {
        this.removeDeparturesFromMap();
        this.drawDeparturesOnMap(stops);
      };
      App.Objects.RouteDetails.getStopDataToLayers(routeId, success);
    };
    this.drawDeparturesOnMap = (stops) => {
      const markers = [];
      const points = [];
      stops.models.forEach((item) => {
        const { id, departureLatitude, departureLongitude, plannedSequenceNum,
          actualSequenceNum, redeliveryStop, redeliveryType, totalRedelivery } = item.get('stop');
        if (departureLatitude && departureLongitude) {
          const marker = Greenmile.RouteDetail.Util.renderNumberedIconMarker({
            id,
            latitude: departureLatitude,
            longitude: departureLongitude,
            plannedSequenceNum,
            actualSequenceNum,
            redeliveryStop,
            kind
          });
          marker
            .bindTooltip(
              Monet.I18n.getResourcesByKey('ToolBar.Layers.Departure'),
              STOP_TOOLTIP_CONFIG
            )
            .on('mouseover', () => marker.openTooltip())
            .on('mouseout', () => marker.closeTooltip());
          markers.push(marker);
          points.push([departureLatitude, departureLongitude]);
        }
      });
      markers.forEach((marker) => {
        map.addLayer(marker);
      });
      if (points.length > 1) {
        map.fitBounds(points);
      }
    };
    this.removeDeparturesFromMap = () => {
      Greenmile.Map.Utility.removeLayerByKind(map, [kind]);
    };
  }
};
